import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import * as qs from "qs";
import axiosApi from "../../utils/httpClient";
const name = "sentToCompany";
const initialState = {
  sentToCompany: [],
  loading: false,
  error: null,
};

export const sentToCompanyAPI = createAsyncThunk(
  "sentToCompany",
  async ({ search, skip, limit, type }) => {
    var formData = {};

    const data = await axiosApi.get(
      `${
        process.env.REACT_APP_BASE_URL
      }company/get-send-interests/?skip=${skip}&limit=${limit}${
        search != "" ? `&search=${search}` : ""
      }`,
      {
        params: formData,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      }
    );
    return data.data;
  }
);

const sentToCompanySlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(sentToCompanyAPI.pending, (state) => {
      state.sentToCompany = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(sentToCompanyAPI.fulfilled, (state, action) => {
      state.sentToCompany = action.payload.data;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(sentToCompanyAPI.rejected, (state, action) => {
      state.sentToCompany = [];
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default sentToCompanySlice.reducer;
